import React, { useEffect } from "react";
import { Typography, Paper, Box } from "@material-ui/core";
import { Link } from "react-router-dom";
import useStyles from "../../styles/dashboardStyle";
import AutorenewRoundedIcon from "@material-ui/icons/AutorenewRounded";
import SmallerLoadingIndicator from "../commons/SmallerLoadingIndicator";
import { NoDataText } from "../commons/ValidationText";
import useStateOnMounted from "../../helpers/useStateOnMounted";
import { useQueryParams } from "@/containers/Dashboard";
import { getAlarmedPolicyListApi } from "@/apis/apiCollection";
import { useTranslation } from "@/langs/useTranslation";

function queryParamsAdapter(params) {
  return {
    groupIds: params.group_ids,
    tagIds: params.tag_ids,
    includeChildCompany: params.hasSubCompanies === 1
  };
}

const AlarmDevicePolicy = props => {
  const classes = useStyles();
  const [list, setList] = useStateOnMounted([]);
  const [reload, setReload] = useStateOnMounted(true);
  const [queryParams] = useQueryParams();
  const { t } = useTranslation();

  const getAlarmedPolicyList = async () => {
    setReload(true);
    const data = await getAlarmedPolicyListApi(queryParamsAdapter(queryParams));
    setList(data.alarmedPolicyOptions);
    setReload(false);
  };

  useEffect(() => {
    getAlarmedPolicyList();
  }, [queryParams]);

  return (
    <Paper elevation={0} style={{ justifyContent: "flex-start" }}>
      <Typography variant="h6" className={classes.cardTitleWrapWithReloadIcon}>
        {props.title}
        <AutorenewRoundedIcon
          onClick={getAlarmedPolicyList}
          size="small"
          className={classes.reload_btn}
        />
      </Typography>
      {!reload ? (
        list.length ? (
          <Box mt="10px" maxHeight={245} overflow="auto">
            {list.map(item => (
              <Box
                key={item.alarmPolicyOptionId}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mb="5px"
                padding={`6px 10px`}
                borderRadius={4}
                bgcolor="#F8F9FC"
              >
                <span className="withDot">{t(item.alarmPolicyOptionName)}</span>
                <Link
                  to={`/alarm/device-list?alarmPolicyOptionId=${item.alarmPolicyOptionId}&triggerStatus=1`}
                >
                  {item.alarmNum}
                </Link>
              </Box>
            ))}
          </Box>
        ) : (
          <NoDataText />
        )
      ) : (
        <SmallerLoadingIndicator />
      )}
    </Paper>
  );
};

export default AlarmDevicePolicy;
